"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecureClient = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _axiosAuthRefresh = _interopRequireDefault(require("axios-auth-refresh"));
var _queryString = _interopRequireDefault(require("query-string"));
var _ApplicationContext = require("./ApplicationContext");
var _SecurityContextHolder = require("./SecurityContextHolder");
var _SecurityContextLogoutHandler = require("./SecurityContextLogoutHandler");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// eslint-disable-next-line import/prefer-default-export
var _http = /*#__PURE__*/new WeakMap();
class SecureClient {
  constructor(baseUrlArg) {
    _classPrivateFieldInitSpec(this, _http, null);
    const baseUrl = typeof baseUrlArg !== 'undefined' ? baseUrlArg : _ApplicationContext.ApplicationContext.getApiBasePath();
    _classPrivateFieldSet(_http, this, _axios.default.create({
      baseURL: baseUrl,
      withCredentials: true
    }));
    _classPrivateFieldGet(_http, this).interceptors.request.use(request => {
      request.headers.Authorization = `Bearer ${_SecurityContextHolder.SecurityContextHolder.getCurrentContext().tokenId}`;
      request.headers['X-Request-ID'] = _SecurityContextHolder.SecurityContextHolder.getRouteUUID();
      if (_ApplicationContext.ApplicationContext.getDataSource()) {
        request.headers.dataSource = _ApplicationContext.ApplicationContext.getDataSource();
      }
      return request;
    });
    const refreshAuthLogic = failedRequest => _classPrivateFieldGet(_http, this).post('/security/auth/refresh', _queryString.default.stringify({
      contextId: _SecurityContextHolder.SecurityContextHolder.getCurrentContext().contextId,
      refreshToken: _SecurityContextHolder.SecurityContextHolder.getCurrentContext().refreshToken
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      skipAuthRefresh: true
    }).then(tokenRefreshResponse => {
      _SecurityContextHolder.SecurityContextHolder.getCurrentContext().doRefresh(tokenRefreshResponse.data);

      // eslint-disable-next-line no-param-reassign
      failedRequest.response.config.headers.Authorization = `Bearer ${_SecurityContextHolder.SecurityContextHolder.getCurrentContext().tokenId}`;
      return Promise.resolve();
    }).catch(error => {
      if (error.response && error.response.status) {
        const {
          status
        } = error.response;

        // Refresh failed
        if (status === 401) {
          _SecurityContextLogoutHandler.SecurityContextLogoutHandler.logout();
          if (window.location.href && window.location.href.endsWith('/logout.html')) {
            window.location.href = '/';
          } else {
            window.location.href = _ApplicationContext.ApplicationContext.getLogoutPath();
          }
        }
      }
      return Promise.reject(error);
    });
    (0, _axiosAuthRefresh.default)(_classPrivateFieldGet(_http, this), refreshAuthLogic);
  }
  get(url, options) {
    return this.getClient().get(url, options);
  }
  postFormData(url, formData) {
    return this.getClient().post(url, formData);
  }
  postBody(url, body) {
    return this.getClient().post(url, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  getClient() {
    return _classPrivateFieldGet(_http, this);
  }
}
exports.SecureClient = SecureClient;
//# sourceMappingURL=SecureClient.js.map